// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {MutableRefObject, useEffect, useRef} from 'react';
// @ts-ignore
import {createRoot} from 'react-dom-client';
import cn from 'classnames';
import zdot from '/util/zdot.js';
// @ts-ignore
import cs_nodejs from 'text!./code_snippets/nodejs.txt';
// @ts-ignore
import cs_curl from 'text!./code_snippets/curl.txt';
// @ts-ignore
import cs_go from 'text!./code_snippets/go.txt';
// @ts-ignore
import cs_php from 'text!./code_snippets/php.txt';
// @ts-ignore
import cs_python3 from 'text!./code_snippets/python3.txt';
import styles from './code_snippet.module.less';

const cs_targets = {
    nodejs: cs_nodejs,
    curl: cs_curl,
    go: cs_go,
    php: cs_php,
    python3: cs_python3,
};

export type t_target = keyof typeof cs_targets;
export interface i_proxy {
    host: string;
    port: string;
    login: string;
    password: string;
}
interface i_highlight {
    text: string;
    hint: JSX.Element | string;
}
export type i_highlights = object_of<i_highlight>;
interface i_code_snippet_props {
    target: t_target;
    proxy: i_proxy;
    highlights?: i_highlights;
    tmpl?: string;
    on_text_change?: (text: string)=>void;
}

export const Code_snippet = React.forwardRef((props: i_code_snippet_props,
    pre_ref: MutableRefObject<HTMLPreElement>)=>
{
    const {target, proxy = {}, on_text_change, highlights, tmpl} = props;
    const text = tmpl || zdot.template(cs_targets[target])(proxy) as string;
    const active_hint = useRef(null);
    useEffect(()=>{
        if (text && on_text_change)
            on_text_change(text);
    }, [target, proxy, text]);
    useEffect(()=>{
        if (!pre_ref?.current || !text)
            return;
        let html = text;
        const session_text = highlights.login.text
            .match(/session-([^-]+)/)?.[1] || null;
        const country_text = highlights.login.text
            .match(/country-([^-]+)/)?.[1] || null;
        const country_session = `country-${country_text}-` +
            `session-${session_text}`;
        Object.keys(highlights).forEach(key=>{
            const h = highlights[key];
            let h_cls: string;
            if (h.text!='_login_' && h.text!='_pass_' && h.text!='_port_' &&
                h.text!='XX' && h.text!='###')
            {
                h.hint = key;
                h_cls = styles.text_highlight;
            }
            if (h.text.includes('country-'))
                h.text = h.text.replace(`-${country_session}`, '');
            html = html.replace(h.text, m=>{
                return `<span class="${cn(h_cls ? h_cls :
                    styles.highlight, styles[key])}">`
                    +`${m}</span>`;
            });
        });
        pre_ref.current.innerHTML = html;
        const highlight_elems = pre_ref.current.querySelectorAll(
            `.${styles.text_highlight}, .${styles.highlight}`);
        Array.from(highlight_elems).forEach((h: HTMLSpanElement)=>{
            const highlight = Object.values(highlights)
                .find(hl=>hl.text == h.textContent);
            if (highlight.hint)
            {
                const hint_el = document.createElement('span');
                hint_el.className = styles.hint;
                const root = createRoot(hint_el);
                root.render(highlight.hint);
                h.appendChild(hint_el);
                if (highlight.hint=='login' || highlight.hint=='password' ||
                    highlight.hint=='port' || highlight.hint=='host')
                {
                    h.addEventListener('mouseenter', e=>{
                        if (active_hint.current)
                            active_hint.current.style.visibility = 'hidden';
                        active_hint.current = hint_el;
                        hint_el.style.opacity = '1';
                        hint_el.style.visibility = 'visible';
                        const rect = h.getBoundingClientRect();
                        const hint_rect = hint_el.getBoundingClientRect();
                        const hint_w = hint_rect.width;
                        const hint_h = hint_rect.height;
                        hint_el.style.left =
                            `${e.clientX - rect.left - hint_w / 2}px`;
                        hint_el.style.top =
                            `${e.clientY - rect.top - hint_h - 2}px`;
                    });
                    h.addEventListener('mouseleave', ()=>{
                        hint_el.style.opacity = '0';
                        hint_el.style.visibility = 'hidden';
                        active_hint.current = null;
                    });
                }
            }
            h.style.setProperty('--h_top', `${h.offsetTop}px`);
        }, 500);
    }, [pre_ref?.current, text, highlights]);
    return <pre ref={pre_ref} className={styles.code_snippet}>{text}</pre>;
});
